import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils";

const scoutLogoMarkSizes = {
  tiny: {
    src: "/logos/scout/scout-logo-xs.png",
    width: 115,
    height: 107,
    className: "size-5 p-1",
  },
  xs: {
    src: "/logos/scout/scout-logo-xs.png",
    width: 115,
    height: 107,
    className: "size-7 p-1",
  },
  sm: {
    src: "/logos/scout/scout-logo-sm.png",
    width: 173,
    height: 166,
    className: "size-9 p-1",
  },
  md: {
    src: "/logos/scout/scout-logo-md.png",
    width: 220,
    height: 195,
    className: "size-10 p-1",
  },
  lg: {
    src: "/logos/scout/scout-logo-lg.png",
    width: 263,
    height: 219,
    className: "size-12 p-1",
  },
  xl: {
    src: "/logos/scout/scout-logo-xl.png",
    width: 310,
    height: 261,
    className: "size-16 p-1",
  },
  hero: {
    src: "/logos/scout/scout-logo-xl.png",
    width: 310,
    height: 261,
    className: "size-24 p-1",
  },
} as const;

export type ScoutLogoMarkSize = keyof typeof scoutLogoMarkSizes;

type ScoutLogoMarkProps = ComponentPropsWithoutRef<"span"> & {
  alt?: string;
  size?: ScoutLogoMarkSize;
  variant?: "default" | "neutral";
};

export function ScoutLogoMark({
  size = "md",
  className,
  alt = "",
  variant = "default",
  ...props
}: ScoutLogoMarkProps) {
  const asset = scoutLogoMarkSizes[size];
  const src = variant === "neutral"
    ? asset.src.replace("/logos/scout/", "/logos/scout-neutral/")
    : asset.src;

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden",
        asset.className,
        className,
      )}
      {...props}
    >
      <img
        src={src}
        alt={alt}
        width={asset.width}
        height={asset.height}
        className="h-full w-full object-contain"
      />
    </span>
  );
}
